// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StartEndTime } from "@ces/App/Handlers/XNG/RequestedPickupTimes";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface ResultModel {
    availableTimes?: string[];
    startEndTime?: StartEndTime;
}

export type RequestedPickupTimesState = {
    result?: ResultModel;
    selectedTime?: string;
};

const initialRequestedPickupTimesState: RequestedPickupTimesState = {};

const xRequestedPickupTimes = createTypedReducerWithImmer(initialRequestedPickupTimesState, {
    "xRequestedPickupTimes/CompleteLoadPickupTimes": (
        draft: Draft<RequestedPickupTimesState>,
        action: { result: ResultModel },
    ) => {
        draft.result = action.result!;
    },
    "xRequestedPickupTimes/ChangeTime": (draft: Draft<RequestedPickupTimesState>, action: { time?: string }) => {
        draft.selectedTime = action.time!;
    },
});

(reducers as any).xRequestedPickupTimes = xRequestedPickupTimes;

export type xRequestedPickupTimesState = {
    xRequestedPickupTimes: RequestedPickupTimesState;
} & ApplicationState;

type xRequestedPickupTimesReducers = {
    xRequestedPickupTimes: typeof xRequestedPickupTimes;
};

export type xRequestedPickupTimesActions =
    | Parameters<xRequestedPickupTimesReducers[keyof xRequestedPickupTimesReducers]>[1]
    | AnyAction;
